import options from './thing-star.component';

export default {
    selector: 'dtAsThingStar',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-star/index.js